import { IErrorPayload } from "@/fe-core/meta/interfaces/root";
import { IJackpotDetailsViewModel } from "../interfaces/jackpotDetails";

export enum jackpotDetailsActionTypes {
  GET_JACKPOT_DETAILS_REQUEST = "GET_JACKPOT_DETAILS_REQUEST",
  GET_JACKPOT_DETAILS_SUCCESS = "GET_JACKPOT_DETAILS_SUCCESS",
  GET_JACKPOT_DETAILS_FAILURE = "GET_JACKPOT_DETAILS_FAILURE",
}

export type GetJackpotDetailsRequestAction = {
  type: jackpotDetailsActionTypes.GET_JACKPOT_DETAILS_REQUEST;
};

export type GetJackpotDetailsSuccessAction = {
  type: jackpotDetailsActionTypes.GET_JACKPOT_DETAILS_SUCCESS;
  payload: IJackpotDetailsViewModel;
};

export type GetJackpotDetailsFailureAction = {
  type: jackpotDetailsActionTypes.GET_JACKPOT_DETAILS_FAILURE;
  payload: IErrorPayload;
};

export type JackpotDetailsActions =
  | GetJackpotDetailsRequestAction
  | GetJackpotDetailsSuccessAction
  | GetJackpotDetailsFailureAction;

export type JackpotDetailsState = {
  pending: boolean;
  jackpotDetails: IJackpotDetailsViewModel | null;
};
